import { render, staticRenderFns } from "./FormUsu.vue?vue&type=template&id=dd811066&"
import script from "./FormUsu.vue?vue&type=script&lang=js&"
export * from "./FormUsu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports